import styled from "styled-components";
import { GRAY, NEAR_WHITE, WHITE } from "../../config";

export const ModalContainer = styled.div<{
  width?: string;
}>`
  display: grid;
  overflow: hidden;
  padding: 1.5rem;
  border-radius: 8px;
  background: ${GRAY};
  min-width: 400px;
  width: ${(props) => props.width ?? "auto"};

  animation: showModalContainer 0.2s ease-in-out;

  @keyframes showModalContainer {
    0% {
      transform: translateY(-20px);
      opacity: 0;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
`;

export const Header = styled.div`
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  color: ${NEAR_WHITE};
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;

  > div:first-child {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    h4 {
      margin-top: 4px;
      font-weight: normal;
      font-size: 12px;
      margin: 0px;
      margin-right: 16px;
    }
  }

  h2 {
    font-weight: bold;
    font-size: 24px;
    margin: 0px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  h3 {
    font-weight: normal;
    font-size: 22px;
    margin: 0px;
  }

  h4 {
    font-weight: bold;
    font-size: 12px;
    margin-right: 16px;
    color: ${WHITE};
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  background: ${GRAY};
  box-sizing: border-box;
  color: ${NEAR_WHITE};
`;

export const Content = styled.div<{ hasFooter: boolean }>`
  overflow: auto;
  max-height: ${({ hasFooter }) => (hasFooter ? "calc(100vh - 200px)" : "calc(100vh - 120px)")};
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const CloseIcon = styled.div`
  display: flex;
  align-self: center;
  transform: rotate(47deg);
  cursor: pointer;
`;
